import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import ParseAvatar from '../../../components/ParseAvatar';

import '../styles/organizer.css';

function InstructorDetails(props) {
  const dialogStyle = {
    width: "320px",
  };

  const actions = [
    <FlatButton
      label="Done"
      primary={true}
      onClick={props.onItemDetailsClose}
    />
  ];

  const item = props.item;

  const itemComponents = (
    <div className='detail-box'>
      <div className='detail-box__header'>
        <ParseAvatar avatar={item.get('avatar')} />
        <div className='detail-box__header__names'>
          <h4>{item.get('fullName')}</h4>
          <p>{item.get('title')}</p>
        </div>
      </div>
      
      <div className='detail-item'>
        <p className='floating-label'>Email</p>
        { item.get('email') != null ? (
          <a href={"mailto:" + item.get('email')}>{item.get('email')}</a>
        ) : null }
      </div>

      <div className='detail-item'>
        <p className='floating-label'>Phone</p>
        <p className='detail-item__title'>{item.get('phone')}</p>
      </div>

      <div className='detail-item'>
        <p className='floating-label'>Notes</p>
        <p className='detail-item__title'>{item.get('notes')}</p>
      </div>
    </div>
  );

  return (
    <Dialog
     title="Instructor Details"
      actions={actions}
      modal={false}
      open={true}
      contentStyle={dialogStyle}
      autoScrollBodyContent={true}
      onRequestClose={props.onItemDetailsClose}>

      <div style={{marginTop: '12px'}}>
        {itemComponents}
      </div>

    </Dialog>
  );
}

export default InstructorDetails;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/InstructorDetails.js